@if (isLoading) {
  <div class="no-items-loader-container">
    <app-loader [isLoading]="isLoading"></app-loader>
  </div>
}
<div [hidden]="!isEmpty" class="noarea" id="NoArea" [ngClass]="{'read-only': !hasAdd}">
  <div (click)="iconClick()">
    <div [ngStyle]="background" class="icon"></div>
    @if (type !== 'frontdoor' && type !== 'on-prem') {
      <div class="title">
        This {{organizationTabs.includes(typeName) ? 'organization' : 'network'}} currently has no {{ typeName }} to display.<br /><span [hidden]="!hasAdd"
        >Tap on the <span class="addExample"></span> to add one.</span
        >
      </div>
    }
    @if (type === 'frontdoor' ) {
      <div class="title">
        This Frontdoor account currently has no {{ typeName }} to display.<br /><span [hidden]="!hasAdd"
        >Tap on the <span class="addExample"></span> to add one.</span
        >
      </div>
    }
    @if (type === 'on-prem' ) {
      <div class="title">
        This account currently has no {{ typeName }} to display.<br /><span [hidden]="!hasAdd"
        >Tap on the <span class="addExample"></span> to add one.</span
        >
      </div>
    }
  </div>
  @if (hiddenResults) {
    <div class="title hidden-results">
      <span
        >Some results have been filtered. <a (click)="enablePowerUser()">Click here</a> to enable
        <b>Power User</b> mode and display hidden results.</span
        >
      </div>
    }
  </div>
